import { Suspense } from "react";
import { Outlet, useNavigation, useRevalidator } from "react-router";
import { ToastContainer } from "react-toastify";

import FarmProvider from "@/contexts/FarmContext";
import TypesProvider from "@/contexts/TranslatedTypes.js";

import LoadingDialog from "@/components/Utils/LoadingDialog";
import ErrorBoundary from "@/components/Utils/ErrorBoundary";

import GATracker from "@/components/GATracker/GATracker";

export const Layout = ({ history }) => {
    const revalidate = useRevalidator();
    const navigation = useNavigation();

    return <ErrorBoundary name="Root">
        {(navigation.state === "loading" || revalidate.state === "loading") && <LoadingDialog />}
        <ToastContainer closeOnClick icon={false} theme="colored" position="top-right" />
        <Suspense fallback={<LoadingDialog />}>
            <div className="control-section">
                <TypesProvider>
                    <FarmProvider>
                        <div>
                            <GATracker history={history} />
                            <Outlet />
                        </div>
                    </FarmProvider>
                </TypesProvider>
            </div>
        </Suspense>
    </ErrorBoundary>;
};
